import type { ApiRequestParam, ApiType } from "@tradingApp/api/types";
import {
  DPS_API_BASE_URL,
  DPS_SERVICE_API_BASE_URL,
  HYPER_PARSER_API_BASE_URL,
  HYPERUNIT_API_BASE_URL,
  PUBLIC_API_BASE_URL,
  SWS_API_BASE_URL,
} from "@tradingApp/constants";

export const API_REQUEST_PARAMS: Record<ApiType, ApiRequestParam> = {
  DPS: {
    baseUrl: DPS_API_BASE_URL,
    options: {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  },
  HYPER_PARSER: {
    baseUrl: HYPER_PARSER_API_BASE_URL,
    options: {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  },
  SWS: {
    baseUrl: SWS_API_BASE_URL,
    options: {
      method: "GET",
    },
  },
  PUBLIC: {
    baseUrl: PUBLIC_API_BASE_URL,
    options: {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  },
  DPS_SERVICE: {
    baseUrl: DPS_SERVICE_API_BASE_URL,
    options: {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  },
  HYPERUNIT: {
    baseUrl: HYPERUNIT_API_BASE_URL,
    options: {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    },
  },
};
